"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    columns: Array,
    measures: Array,
    rows: Array,
    transport: Object,
    schema: Object
};